import { Comment } from './comment.model';

export class Comments {
  success: boolean;
  comments: Comment[];
}
